import { createSelector } from '@reduxjs/toolkit'

// TODO: import Store type and add reducer type in Store interface
const getMetrics = (state: any) => state.metrics

export const metricsSelector = createSelector(getMetrics, (metrics) => metrics)
